// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tkjutfvxgitjbrggxhvz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRranV0ZnZ4Z2l0amJyZ2d4aHZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAwMzIyMjEsImV4cCI6MjA4NTYwODIyMX0.p4x_wwzP9x2kkJR1sIKshMwEMIGe36ilB4vQnUE7cSc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});